import { useState } from 'react';
import { type RaRecord, useRecordContext } from 'ra-core';
import { useParams } from 'react-router-dom';
import { MoonstarEdit } from '../../Moonstar/MoonstarEdit';
import { MoonstarEditForm } from '../../Moonstar/MoonstarEditForm';
import { NudgeSlideInputs, type NudgeSlideTab } from './NudgeSlideInputs';

export const NudgeSlideEdit = () => {
  const { nudgeId } = useParams();
  const redirect = () => `nudges/${nudgeId}/slides`;

  return (
    <MoonstarEdit redirect={redirect} onDeleteRedirect={redirect}>
      <NudgeSlideEditWrapper />
    </MoonstarEdit>
  );
};

const NudgeSlideEditWrapper = () => {
  const record = useRecordContext();
  if (!record) return null;
  return <NudgeSlideEditForm key={record.id} record={record} />;
};

const NudgeSlideEditForm = ({ record }: { record: RaRecord }) => {
  // Opens on the tab of the slide's kind
  const [selectedTab, setSelectedTab] = useState<NudgeSlideTab>(
    record.url ? 'withUrl' : 'withContentAndImage'
  );

  return (
    <MoonstarEditForm className="max-w-none">
      <NudgeSlideInputs
        selectedTab={selectedTab}
        onTabChange={setSelectedTab}
      />
    </MoonstarEditForm>
  );
};
